import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Input,
  FormGroup,
  CustomInput,
  Button,
  ButtonGroup,
  Form,
  Modal,
  ModalBody,
  InputGroup,
  Label
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import {
  gAPI_Property_List_By_Group,
  API_REST_API,
  API_Phone_Suite_Interation_Group,
  API_CONNECTWARE,
} from '../../../../../../constants/APIs';
import { NotificationManager } from '../../../../../../components/common/react-notifications';


let arr = [];
export default function RESTApiIntegration({ visible, toggle, id, LoadIntegrations }) {
  const [property, setProperty] = useState([]);
  const [inputData, setInputData] = useState({
    GroupId: getGroupID(),
    Name: '',
    Properties: [],
    SessionTimeoutInSeconds: 600,
    DefaultLanguage: 'en-US',
    description: '',
    collectionName: ''
  });
  useEffect(() => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
    })
      .then((res) => {
        setProperty([...res.data]);
      })
      .catch((err) => console.error(err));
  }, [id]);


  const handleNameChange = (e) => {
    e.persist();
    setInputData({ ...inputData, Name: e.target.value });
  };


  const handleCheckChange = (e) => {
    if (e.target.checked) {
      arr[e.target.id] = e.target.value;
    }
    if (!e.target.checked) {
      arr[e.target.id] = undefined;
    }
    const filterList = arr.filter((elem) => elem !== undefined || null);
    setInputData({ ...inputData, Properties: filterList });
  };

  const handleSave = async () => {
    AxiosAPI({
      method: 'post',
      url: API_REST_API,
      data: inputData,
    }).then((res) => {
      LoadIntegrations();
      toggle();
    });
  };
  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle}>
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              <div className="text-center">
                <h6>{id === undefined ? "Add" : "Update"} Rest Api</h6>
                <Separator className="mb-3" />
                <Form className="text-left">
                  <FormGroup className="mb-2">
                    <Label>Integration Name</Label>
                    <Input
                      type="text"
                      name="integrationName"
                      onChange={handleNameChange}
                      placeholder="Integration Name"
                      defaultValue={inputData.Name}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>Collection Name</Label>
                    <Input
                      type="text"
                      name="collectionName"
                      onChange={(e) => setInputData({ ...inputData, collectionName: e.target.value })}
                      placeholder="Collection Name"
                      defaultValue={inputData.collectionName}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>Description</Label>
                    <Input
                      type="text"
                      name="description"
                      onChange={(e) => setInputData({ ...inputData, description: e.target.value })}
                      placeholder="Description"
                      defaultValue={inputData.description}
                    />
                  </FormGroup>
                  <FormGroup className="mt-3">
                    <div className='integration-property text-left'>
                      {property.map((p, index) => {
                        return (
                          <CustomInput
                            key={p.id}
                            type="checkbox"
                            id={index}
                            label={p.name}
                            value={p.id}
                            name="property"
                            onChange={handleCheckChange}
                          />
                        );
                      })}
                    </div>
                  </FormGroup>
                </Form>
                <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                  {id === undefined ? (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      Create New Integration
                    </Button>
                  ) : (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      Update Integration
                    </Button>
                  )}
                  <Button size="xs" color="dark" outline onClick={toggle}>
                    Cancel
                  </Button>
                </ButtonGroup>
              </div>
            </Colxx>
          </Row>
        </ModalBody>
      </Modal>
    </Fragment>
  );
}

